import { UserInfo } from "packages/tvg-lib-ts-types/User";

export const createConversation = ({
  accountNumber,
  firstName,
  lastName,
  emailAddress,
  profile,
  homeAddress,
  primaryPhone
}: UserInfo) => {
  if (typeof window !== "undefined" && window.ApptentiveSDK) {
    const payload = {
      app_release: {
        version: "1.0.0"
      },
      person: {
        custom_data: {
          account_id: accountNumber,
          first_name: firstName,
          last_name: lastName,
          email: emailAddress,
          day_of_birthday: "",
          home_city: homeAddress ? homeAddress.state : "",
          gender: "",
          country: homeAddress ? homeAddress.country : "",
          phone: primaryPhone,
          full_home_address: "",
          key_account_yn: false,
          value_band: profile
        }
      },
      device: {
        custom_data: {
          flash: true,
          es6: false
        }
      }
    };
    window.ApptentiveSDK.createConversation(payload);
  }
};

export const engageApptentiveEvent = (eventName: string) => {
  if (typeof window !== "undefined" && window.ApptentiveSDK) {
    window.ApptentiveSDK.engage(eventName);
  }
};
